import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-page-unavailable',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './page-unavailable.component.html',
  styleUrls: ['./page-unavailable.component.css'],
})
export class PageUnavailableComponent {
  @Input() lockScreenWithoutDevice = false;
}
